import script from "./PexCollectionAssetNext.vue?vue&type=script&setup=true&lang=js"
export * from "./PexCollectionAssetNext.vue?vue&type=script&setup=true&lang=js"

import "./PexCollectionAssetNext.vue?vue&type=style&index=0&id=08adc7ba&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\CSD.SPA\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08adc7ba"]])

export default __exports__